import { keyframes } from 'styled-components/macro';
import { colourGreen06, colourNeutral01 } from './colours';

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  
  to {
    opacity: 1;
  }
`;

export const flash = keyframes`
  0% {
    color: ${colourNeutral01};
  }
  
  25% {
    color: ${colourGreen06};
  }
  
  50% {
    color: ${colourNeutral01};
  }
  
  75% {
    color: ${colourGreen06};
  }
  
  100% {
    color: ${colourNeutral01};
  }
`;
